(function () {
  var loading = false;
  var currentPage = 1;
  var totalPages = 23; // hårdkodat för säkerhets skull

  function getTotalPages() {
    var max = 1;
    document.querySelectorAll('a[href*="page="]').forEach(function(a) {
      var match = a.href.match(/page=(\d+)/);
      if (match) max = Math.max(max, parseInt(match[1]));
    });
    return max;
  }

  function hidePagination() {
    var nav = document.querySelector('nav.pagination, .pagination');
    if (nav) nav.style.display = 'none';
  }

  function loadNextPage() {
    if (loading || currentPage >= totalPages) return;
    loading = true;
    currentPage++;

    var url = window.location.pathname + '?page=' + currentPage;
    // Bevara sort_by om det finns
    var sortMatch = window.location.search.match(/sort_by=[^&]+/);
    if (sortMatch) url += '&' + sortMatch[0];

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'text/html');
        var grid = document.querySelector('ul#product-grid');
        var newItems = doc.querySelectorAll('ul#product-grid li');
        newItems.forEach(function(item) {
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          grid.appendChild(item);
        });
        totalPages = getTotalPages();
        loading = false;
      })
      .catch(function(e) {
        console.error(e);
        currentPage--;
        loading = false;
      });
  }

  window.addEventListener('scroll', function() {
    var dist = document.documentElement.scrollHeight - window.scrollY - window.innerHeight;
    if (dist < 3000) loadNextPage();
  }, { passive: true });

  hidePagination();

  console.log('Infinity scroll loaded, totalPages:', getTotalPages());
})();